// ============================================================
// LastEditedLine — "Last edited by [Name] · [relative time]" (schema batch 2)
//
// Shown on the task + appointment VIEW when someone OTHER than the item's owner
// made the last edit (the owner's own edits are noise — they know). Renders
// nothing when the fields are absent, so it degrades gracefully before
// Reuben's push (columns not returned) and for never-edited items. The name is
// resolved live from the central firmUsers list (useLiveUserName), so a rename
// shows everywhere at once. Token colours → light + dark.
// ============================================================
import React from 'react'
import { useLiveUserName } from '../../hooks/useLiveUserName'
import { relativeTime } from '../../utils/relativeTime'

interface Props {
  editorId?: string | null
  editedAt?: string | null
  ownerId?: string | null
  className?: string
}

const LastEditedLine: React.FC<Props> = ({ editorId, editedAt, ownerId, className }) => {
  const nameOf = useLiveUserName()
  if (!editorId || !editedAt || editorId === ownerId) return null
  const name = nameOf(editorId, 'a former member')
  const exact = new Date(editedAt)
  return (
    <p className={`text-xs text-casevo-text-soft ${className ?? ''}`}>
      Last edited by <span className="font-medium text-casevo-forest">{name}</span>
      {' · '}
      <time dateTime={editedAt} title={Number.isNaN(exact.getTime()) ? undefined : exact.toLocaleString('en-GB')}>
        {relativeTime(editedAt)}
      </time>
    </p>
  )
}

export default LastEditedLine
